import { Button, Dialog } from '@buffer-mono/popcorn'

import { formatPeriodEnd } from './formatPeriodEnd'

import type { JSX } from 'react'

type SuccessStepProps = {
  periodEnd: string | null
  isTrialCancellation: boolean
  onDismiss: () => void
}

export const SuccessStep = ({
  periodEnd,
  isTrialCancellation,
  onDismiss,
}: SuccessStepProps): JSX.Element => {
  const formattedPeriodEnd = formatPeriodEnd(periodEnd)

  return (
    <>
      <Dialog.Header>
        <Dialog.Title>Your Subscription Has Been Canceled</Dialog.Title>
      </Dialog.Header>
      <Dialog.Body>
        <Dialog.Description>
          {isTrialCancellation ? (
            <>
              Your trial has been canceled. You’re now on the Free plan. You can
              reactivate your plan anytime if you change your mind.
            </>
          ) : (
            <>
              Your subscription has been canceled.{' '}
              {formattedPeriodEnd ? (
                <>
                  You will continue to have access to paid features until{' '}
                  <strong>{formattedPeriodEnd}</strong>.{' '}
                </>
              ) : (
                'You will continue to have access to paid features until the end of your current billing period. '
              )}
              You can reactivate your plan anytime if you change your mind.
            </>
          )}
        </Dialog.Description>
      </Dialog.Body>

      <Dialog.Footer>
        <Button variant="primary" size="large" onClick={onDismiss}>
          Done
        </Button>
      </Dialog.Footer>
      <Dialog.CloseButton />
    </>
  )
}
